/**
 * Home の TODO ウィジェットから開くクイック追加ダイアログ。
 *
 * TODO ページと同じ 1 行入力をそのまま出し、追加できたら閉じる。
 * プロジェクト候補は Todo ストアの中身から作られるので、開くたびに TODO ページを開いたときと同じ条件
 * （前回の表示モード。完了済みの表示は TODO ページでも毎回オフから始まる）で読み直し、候補を揃える。
 */

import { useEffect } from 'react'

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { TodoInput } from '@/pages/todo/TodoInput'
import { readStoredViewMode, shouldIncludeDone } from '@/pages/todo/view-mode'
import { useTodoStore } from '@/store/useTodoStore'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
  onAdded: () => void
}

export const TodoQuickAddDialog = ({ open, onOpenChange, onAdded }: Props) => {
  const loadTodos = useTodoStore((s) => s.loadTodos)

  useEffect(() => {
    if (!open) return
    void loadTodos({ include_done: shouldIncludeDone(readStoredViewMode(), false) })
  }, [open, loadTodos])

  const handleAdded = () => {
    onAdded()
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="top-[20%] translate-y-0">
        <DialogHeader>
          <DialogTitle>TODO を追加</DialogTitle>
          <DialogDescription className="sr-only">追加するタスクを入力してください</DialogDescription>
        </DialogHeader>
        {/* 下に一覧が無いので、重ねずに差し込んでダイアログの中に収める */}
        <TodoInput onAdded={handleAdded} pickerPlacement="inline" />
      </DialogContent>
    </Dialog>
  )
}
